<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="list">全部投放记录</el-menu-item>
          <el-menu-item index="batch">批次提交记录</el-menu-item>
          
        </el-menu>
      </div>
      <div class="content-wrap">
        <record-list v-if="activeIndex == 'list'"></record-list>
        <record-batch v-if="activeIndex == 'batch'" @toDeliveryList="dealToRecordList"></record-batch>
      </div>
    </div>
  </div>
</template>

<script>
import recordList from "./component/list";
import recordBatch from "./component/batchlist";
import { mapGetters } from "vuex";

export default {
    computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  data() {
    return {
      activeIndex: "list",
      queryData: {}
    };
  },
  components: {
    recordList,
    recordBatch
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    dealToRecordList() {
      this.activeIndex = 'list';
    }
  }
}
</script>